module.exports = __webpack_public_path__ + "static/media/Approved.c08d8c51.svg";